import type { QaDrillResponse, QaMonthsResponse, QaSummary } from "@tienda/shared";

const baseUrl = (import.meta.env.VITE_API_BASE_URL || "").replace(/\/$/, "");

async function getJson<T>(path: string): Promise<T> {
  const response = await fetch(`${baseUrl}${path}`, { headers: { accept: "application/json" } });
  const body = (await response.json()) as T & { ok?: boolean; error?: string };
  if (!response.ok || body.ok === false) {
    throw new Error(body.error || `request_failed_${response.status}`);
  }
  return body;
}

export function fetchMonths(): Promise<QaMonthsResponse> {
  return getJson<QaMonthsResponse>("/api/v1/qa/months");
}

export function fetchSummary(month: string, agent: string | null): Promise<QaSummary> {
  const query = new URLSearchParams({ month });
  if (agent) query.set("agent", agent);
  return getJson<QaSummary>(`/api/v1/qa/summary?${query.toString()}`);
}

export function fetchDrill(month: string, agent: string | null): Promise<QaDrillResponse> {
  const query = new URLSearchParams({ month, pageSize: "20" });
  if (agent) query.set("agent", agent);
  return getJson<QaDrillResponse>(`/api/v1/qa/drill?${query.toString()}`);
}
